//Utils
import { isJavascriptEnabled } from './utils/isJavascriptEnabled';
import { getFocusable } from './utils/getFocusable';
import { nextFocusable } from './utils/nextFocusable';
import { isPrintableChar } from './utils/isPrintableChar';
import { isInputable } from './utils/isInputable';
import { isSet } from './utils/isSet';

//Funtions
import { initEmblaCarousels } from "./functions/emblaCarouselInit";

//Classes
import { Layer } from "./classes/Layer";
import { Accordion } from "./classes/Accordion";
import { Dropdown } from "./classes/Dropdown";
import { Table } from "./classes/Table";
import { SiteSearch } from "./classes/SiteSearch";
import { DepotFinder } from "./classes/DepotFinder";
import { ContactMap } from "./classes/ContactMap";
import { Hire } from "./classes/Hire";


isJavascriptEnabled();


const focusableElements = [
    'a[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'area[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe:not([disabled]):not([hidden]):not([aria-hidden])',
    'object:not([disabled]):not([hidden]):not([aria-hidden])',
    'embed:not([disabled]):not([hidden]):not([aria-hidden])',
    '[contenteditable]:not([disabled]):not([hidden]):not([aria-hidden])',
    '[tabindex]'
];
window.focusableElements = focusableElements;

const store = {
    activeLayers: [],
    activeLayer: ''
};
window.store = store;


/**
 * Initialise any and all carousels
 */
initEmblaCarousels();


/**
 * Initialise the Live Site Search Bar
 */
const siteSearch = document.querySelector('.site-search--js');
if(isSet(siteSearch)){
    new SiteSearch(siteSearch);
}


/**
 * LAYERS
 */
const layers = document.querySelectorAll('.layer--js');
layers.forEach( function (layerElement) {
    new Layer(layerElement, {
        awaitCloseAnimation: true,
        awaitOpenAnimation: true,
    });
});


/**
 * MAIN MENU
 */
const menuDropdowns = document.querySelectorAll('.sub-menu--js');
menuDropdowns.forEach( function (menuElement) {
    new Dropdown(menuElement, {
    });
});


/**
 * ACCORDIONs
 */
const accordions = document.querySelectorAll('.accordion--js');
accordions.forEach( function (accordionElement) {
    const accordion = new Accordion(
        accordionElement, 
        {
            collapsible: true
        }
    );
});

const basketItemAccordions = document.querySelectorAll('.basket__list--js');
basketItemAccordions.forEach( function (basketItem) {
    const accordion = new Accordion(
        basketItem, 
        {
            collapsible: true,
            type: "multiple"
        }
    );
});

const basketItemLines = document.querySelectorAll('.basket-item__line--js');
basketItemLines.forEach( function (basketItemLine) {
    new Table(basketItemLine);
});

/**
 * Initialise Google Maps API & Maps
 */
(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
    key: "AIzaSyCVf71P8-ZGTehNNSMdNQlFtv8xY3FWzOc",
    v: "weekly",
});

const depotFinderContainer = document.querySelector('.depot-finder--js');
if(isSet(depotFinderContainer)){
    // Initialize and add the map
    async function initDepotFinderMap() {
        const {Map, InfoWindow} = await google.maps.importLibrary("maps");
        const {Marker} = await google.maps.importLibrary("marker");
        
        new DepotFinder(depotFinderContainer, Map, Marker, InfoWindow);
    }

    initDepotFinderMap();
}

const contactContainer = document.querySelector('.contact--js');
if(isSet(contactContainer)){
    // Initialize and add the map
    async function initContactMap() {
        const {Map, InfoWindow} = await google.maps.importLibrary("maps");
        const {Marker} = await google.maps.importLibrary("marker");
        
        new ContactMap(contactContainer, Map, Marker, InfoWindow);
    }

    initContactMap();
}


const hireJourneyContainer = document.querySelector('.hire-journey--js');
if(isSet(hireJourneyContainer)){
    async function initHireJourney() {
        const {Place, AutocompleteSessionToken, AutocompleteSuggestion} = await google.maps.importLibrary("places");

        new Hire(hireJourneyContainer, Place, AutocompleteSessionToken, AutocompleteSuggestion);
    }

    initHireJourney();
}

